import $ from 'jquery';
// import fullpage from 'fullpage.js/dist/fullpage.extensions.min.js';
import 'slick-carousel';
import AOS from 'aos/dist/aos.js';

/*
  Animate on scroll init
 */
$(function() {
  AOS.init();
});

window.addEventListener('load', AOS.refresh);


// Smooth scrolling to anchor
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// 
// $( document ).ready(function() {
//
//
//
// });

/*
  Fullpage.js init
*/
//
// function getWidth() {
//   return Math.max(
//     document.body.scrollWidth,
//     document.documentElement.scrollWidth,
//     document.body.offsetWidth,
//     document.documentElement.offsetWidth,
//     document.documentElement.clientWidth
//   );
// }

$('.recommendation-carousel').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: true,
  // prevArrow: '<img src="/wp-content/themes/bojtterapia/build/img/icon-left-arrow.svg" class="slick-prev">',
  // nextArrow: '<img src="/wp-content/themes/bojtterapia/build/img/icon-right-arrow.svg" class="slick-next">'
});
